/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SwapRouterMock,
  SwapRouterMockInterface,
} from "../SwapRouterMock";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address",
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address",
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
        ],
        internalType: "struct SwapRouterMock.ExactInputSingleParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060928061001e6000396000f3fe608060405260043610601c5760003560e01c8063414bf389146021575b600080fd5b6032602c3660046044565b50600090565b60405190815260200160405180910390f35b60006101008284031215605657600080fd5b5091905056fea26469706673582212204d76daefaca695e8814064958914aec1af75c1e6b1552dc38c94d19111e0c36864736f6c634300080d0033";

type SwapRouterMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SwapRouterMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SwapRouterMock__factory extends ContractFactory {
  constructor(...args: SwapRouterMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SwapRouterMock";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SwapRouterMock> {
    return super.deploy(overrides || {}) as Promise<SwapRouterMock>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SwapRouterMock {
    return super.attach(address) as SwapRouterMock;
  }
  connect(signer: Signer): SwapRouterMock__factory {
    return super.connect(signer) as SwapRouterMock__factory;
  }
  static readonly contractName: "SwapRouterMock";
  public readonly contractName: "SwapRouterMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SwapRouterMockInterface {
    return new utils.Interface(_abi) as SwapRouterMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SwapRouterMock {
    return new Contract(address, _abi, signerOrProvider) as SwapRouterMock;
  }
}
